import { render, staticRenderFns } from "./emas.vue?vue&type=template&id=0539f324&"
import script from "./emas.vue?vue&type=script&lang=js&"
export * from "./emas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports